export default function initContactForm() : void {
    const $contactForm = document.querySelector<HTMLFormElement>('.js-contact-form');
    if ($contactForm) {
        new ContactForm($contactForm);
    }
}

class ContactForm {
    $form: HTMLFormElement;
    $subjectField: HTMLSelectElement|null;
    $myPersonalDataRow: HTMLElement|null;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$subjectField = $form.querySelector<HTMLSelectElement>('.js-subject-field');
        this.$myPersonalDataRow = $form.querySelector<HTMLElement>('.js-my-personal-data');

        if (this.$subjectField && this.$myPersonalDataRow) {
            this.onSubjectFieldChange();

            this.$subjectField.addEventListener('change', () => {
                this.onSubjectFieldChange();
            });
        }
    }

    onSubjectFieldChange() : void {
        if (!this.$subjectField || !this.$myPersonalDataRow) {
            return;
        }

        this.$myPersonalDataRow.classList.toggle('hidden', this.$subjectField.value !== this.$myPersonalDataRow.dataset.handler);
    }
}
